// extracted by mini-css-extract-plugin
export default {"CardAngka":"CardAngka_CardAngka__YhJvc","angka":"CardAngka_angka__spmfi","deskripsi":"CardAngka_deskripsi__NOBxH"};